/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Page Loader.
 */

import React from "react";

import LoadingLogo from "../assets/images/loader.svg";

export const PageLoader = () => {

    return (
        <div>
            <div className="loader">
                <img src={LoadingLogo} alt="Loading..."/>
            </div>
        </div>
    );
};
